/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Status_Documents_UploadedInputs */

const en_inbound_status_documents_uploaded = /** @type {(inputs: Inbound_Status_Documents_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packing list to type`)
};

/**
* | output |
* | --- |
* | "Packing list to type" |
*
* @param {Inbound_Status_Documents_UploadedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_status_documents_uploaded = /** @type {((inputs?: Inbound_Status_Documents_UploadedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Status_Documents_UploadedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_status_documents_uploaded(inputs)
});